import type { FaireThemeEntity } from "../../entity_types/theme";

export const global_curiosity_cravings: FaireThemeEntity = {
  token: "global-curiosity-cravings",
  type: "theme",
  name: "Global Curiosity Cravings",
  description: "Unique snacks from across the pond to surprise your regulars. These rare international finds are perfect for adding a touch of discovery to your gift shop checkout.",
  teaser: "This theme fits Shiva's Gift Shop because you already have a history of ordering international brands like Milka, Ferrero, and Kinder. Your customers clearly appreciate imported gourmet treats.",
  detail: "The additional_context supports this through the German-imported Hanuta Hazelnut Wafers, the Haribo Pasta Penne Sauer from Germany, and the curated bulk pack of rare foreign drinks.",
  bgColor: "#D4C4B0",
  tileBgColor: "#3a4c6b",
  exactProducts: true,
  retailerToken: "r_31m33roqxk",
  productTokens: [
    "p_ur2s5exw8g",
    "p_m6t6ank5nn",
    "p_te6atunau3",
    "p_que8rz3c2r",
    "p_7g37ht83p8",
    "p_9jcy7tkfgd",
    "p_vntmkzc5sw",
    "p_up9q4pqr8p",
    "p_bnjkzqmazs",
    "p_pdwtrveqgt",
    "p_h65ycjtpe4",
    "p_3dqqc9gutg",
    "p_a4b4h87rgb",
    "p_vmvr73nqmh",
    "p_32utgwdgr3",
    "p_ub8hd6np79",
    "p_bxru223vd5",
    "p_ej58bmvmjx",
    "p_qksypy2k78",
    "p_ng86adtb4j",
    "p_dc95mtx7p8",
    "p_z8e6hhcaea",
    "p_2sttmv6gqe",
    "p_2v1cbpnk2a",
    "p_c4z3xadpq7",
    "p_99sq6yt6xg",
    "p_j6qyqpbqcm",
    "p_13tgn8tetl",
    "p_phz4ynyscm",
    "p_m2dr4d3xa4",
    "p_36afngmp3v",
    "p_zsxvmkp5yk",
    "p_58t39dga2a",
    "p_f3yxgc29pu",
    "p_cp5xpq6k5h",
    "p_q7f2bry674",
    "p_kuyzbp7eek",
    "p_gnpue8sww9",
    "p_6kgfgv94cf",
    "p_4xd9mfkt5p",
    "p_gds2rb5gux",
    "p_qs8hjcynwh",
    "p_xfyv4mrk67",
    "p_n83442wbwf",
    "p_avdqv6w9sg",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-26T00:00:00Z",
    importedBy: "manual-v3-import",
  },
};
